import type { CSSProperties, ReactNode } from "react";
import { C } from "../tokens";

interface Props {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glow?: boolean;
  accent?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

/** The signature CoreMonit card — dark glass with a faint neon border. */
export function GlassCard({
  children,
  className = "",
  hover = true,
  glow = false,
  accent,
  style,
  onClick,
}: Props) {
  const borderColor = accent ?? C.border;
  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        background: `linear-gradient(180deg, ${C.surface} 0%, ${C.surfaceHigh} 100%)`,
        border: `1px solid ${borderColor}`,
        borderRadius: 16,
        boxShadow: glow
          ? `0 0 24px rgba(45,127,249,0.2), inset 0 0 0 1px rgba(45,127,249,0.05)`
          : `0 6px 20px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.02)`,
        transition: "border-color 0.2s, transform 0.2s, box-shadow 0.2s",
        cursor: onClick ? "pointer" : "default",
        ...(hover && onClick
          ? { }
          : { }),
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!hover) return;
        (e.currentTarget as HTMLDivElement).style.borderColor = C.borderBright;
      }}
      onMouseLeave={(e) => {
        if (!hover) return;
        (e.currentTarget as HTMLDivElement).style.borderColor = borderColor;
      }}
    >
      {children}
    </div>
  );
}
